module.exports = __webpack_public_path__ + "static/media/default.f05125b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/images/default.jpg
// module id = 564
// module chunks = 0